// Amaya Pro product catalog — sourced from the Amaya Pro Master Specs.
// Only source-supported values are published. Corrupted/ambiguous values are
// marked "See datasheet" instead of guessed.

const SYS = [
  "Bluetooth Mesh connectivity",
  "PSA Level 3 security",
  "Personalized remote control for user-specific lighting preferences",
  "Automatic health status updates continuously reported to the server",
  "Programming of controls via commissioning remote",
  "Handheld remote available for on-demand custom user preference",
  "Robust online portal for pre-planning, pre & post programming, location controls and energy data",
];

const DIM = [
  "All luminaires on the 0–10V control line can be broadcast-controlled via the mobile app",
  "Built-in 20mA 0–10V analog signal output for reliable dimming control",
];

const SCHED = "Clock-dial scheduling for precise time-based control and automation";
const BTN_RESET = "Button reset (5-second press) and remote reset via RESET + ON/OFF";
const REMOTE_RESET = "Remote reset via RESET + ON/OFF";
const SEE_DS = "See datasheet";

const caps = {
  indoor: ["Occupancy Sensor", "Daylight Harvesting", "Bi-Level Dimming", "High-End Trim", "Scheduling"],
  outdoor: ["Occupancy Sensor", "Photocell", "Bi-Level Dimming", "High-End Trim", "Scheduling"],
  node: ["Bi-Level Dimming", "High-End Trim", "Scheduling"],
  pack: ["High-End Trim", "Scheduling"],
  pirswitch: ["Occupancy Sensor", "Scheduling"],
};

export const products = [
  {
    id: "06901", orderNumber: "06901", name: "DC Powered BLE Controls — OcuSense",
    category: "Indoor", sensor: "OcuSense", power: "DC",
    applications: ["Office", "Low-Bay"],
    tagline: "OcuSense fixture control for office and low-bay lighting.",
    overview: ["OcuSense detection", "Wide detection coverage", "Office / low-bay application ready", "Mounting height up to 13 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, "Magnetic reset by touching the top of the sensor for 5 seconds"],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "10–14V DC", "Mounting Height": "Up to 13 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06901.png",
  },
  {
    id: "06902", orderNumber: "06902", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["Office", "Low-Bay"],
    tagline: "PIR fixture control with trim, zoning and bi-level dimming.",
    overview: ["PIR motion detection", "Wide detection coverage", "Office / low-bay application ready", "Mounting height up to 13 ft", "Bluetooth Mesh connectivity", "Trim, zoning & bi-level dimming"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "10–14V DC", "Mounting Height": "Up to 13 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours" },
    image: "/products/06902.png",
  },
  {
    id: "06903", orderNumber: "06903", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["Office", "Low-Bay"],
    tagline: "PIR fixture control with 360° coverage for office and low-bay spaces.",
    overview: ["PIR motion detection", "Wide detection coverage", "Office / low-bay application ready", "Mounting height up to 13 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, BTN_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "10–14V DC", "Mounting Height": "Up to 13 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06903.png", darkImage: true,
  },
  {
    id: "06904", orderNumber: "06904", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["Low-Bay"],
    tagline: "PIR low-bay control with magnetic reset and 15 ft mounting.",
    overview: ["PIR motion detection", "Wide detection coverage", "Low-bay application ready", "Mounting height up to 15 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, "Magnetic reset by touching the side of the sensor for 5 seconds"],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "10–14V DC", "Mounting Height": "Up to 15 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": SEE_DS, "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06904.png",
  },
  {
    id: "06905", orderNumber: "06905", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["High-Bay"],
    tagline: "High-bay PIR control with L8 lens, mounting up to 40 ft.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, "Magnetic reset by touching the side of the sensor for 5 seconds"],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "10–14V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Lens": "L8" },
    image: "/products/06905.png",
  },
  {
    id: "06914", orderNumber: "06914", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["Office", "Low-Bay"],
    tagline: "Compact PIR fixture control for office and low-bay applications.",
    overview: ["PIR motion detection", "Wide detection coverage", "Office / low-bay application ready", "Mounting height up to 13 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "10–14V DC", "Mounting Height": "Up to 13 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": SEE_DS, "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06914.png",
  },
  {
    id: "06906", orderNumber: "06906", name: "DC Powered Indoor BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 high-bay PIR control on 12–24V with 4-port connection.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, BTN_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 104°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06906.png",
  },
  {
    id: "06907", orderNumber: "06907", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 PIR control for high-bay mounting up to 50 ft.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 50 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, BTN_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 50 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 104°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06907.png",
  },
  {
    id: "06908", orderNumber: "06908", name: "DC Powered BLE Controls — OcuSense",
    category: "Indoor", sensor: "OcuSense", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 OcuSense high-bay control with 360° coverage.",
    overview: ["OcuSense motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 104°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06908.png",
  },
  {
    id: "06909", orderNumber: "06909", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 PIR high-bay control with G1/2 threaded entry.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": SEE_DS, "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Thread": "G1/2" },
    image: "/products/06909.png",
  },
  {
    id: "06910", orderNumber: "06910", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 PIR high-bay control, mounting up to 50 ft, G1/2 entry.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 50 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 50 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": SEE_DS, "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Thread": "G1/2" },
    image: "/products/06910.png",
  },
  {
    id: "06911", orderNumber: "06911", name: "DC Powered BLE Controls — OcuSense",
    category: "Indoor", sensor: "OcuSense", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 OcuSense high-bay control with extended temperature range.",
    overview: ["OcuSense motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Thread": "G1/2" },
    image: "/products/06911.png",
  },
  {
    id: "06915", orderNumber: "06915", name: "DC Powered BLE Controls — PIR",
    category: "Indoor", sensor: "PIR", power: "DC",
    applications: ["High-Bay"],
    tagline: "IP65 PIR high-bay control with G1/2 entry, up to 40 ft.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 140°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Thread": "G1/2" },
    image: "/products/06915.png",
  },
  {
    id: "06913", orderNumber: "06913", name: "DC Powered BLE Controls — Node",
    category: "Node", sensor: null, power: "DC",
    applications: ["High-Bay"],
    tagline: "Bluetooth node to be paired with full control.",
    overview: ["Bluetooth node to be paired with full control", "Wide detection coverage", "High-bay application ready", "Max Bluetooth range 100 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, BTN_RESET],
    capabilities: caps.node,
    specs: { "Input Voltage": "10–14V DC", "Max Bluetooth Range": "100 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 140°F", "IP Rating": "IP65", "Life Span": ">70,000 hours" },
    image: "/products/06913.png",
  },
  {
    id: "06934", orderNumber: "06934", name: "AC Powered BLE Power Pack Node",
    category: "Node", sensor: null, power: "AC",
    applications: ["High-Bay"],
    tagline: "UL Listed power pack node with 20A relay and 0–10V output.",
    overview: ["Power Pack Node", "Wide detection coverage", "High-bay application ready", "Bluetooth Mesh connectivity", "360° coverage pattern", "Built-in 20mA 0–10V signal output with 20A relay", "Supports Kinetic Energy Switches"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, BTN_RESET],
    capabilities: caps.pack,
    compliance: ["UL Listed, Category PAZX (Management Equipment, Energy)", "UL 2043 Plenum Rated", "IPEX antenna"],
    specs: { "Input Voltage": "120–347V", "Mounting Height": "NA", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "32°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Output": "20mA 0–10V signal, 20A relay", "Antenna": "IPEX" },
    image: "/products/06934.png",
  },
  {
    id: "06935", orderNumber: "06935", name: "AC Powered BLE Power Pack Node",
    category: "Node", sensor: null, power: "AC",
    applications: ["High-Bay"],
    tagline: "Power pack node with phase-cut TRIAC dimming.",
    overview: ["Power Pack Node", "Wide detection coverage", "High-bay application ready", "Bluetooth Mesh connectivity", "360° coverage pattern", "Phase-cut TRIAC dimming to a connected lighting load", "Dimming: forward / reverse phase"],
    features: ["Wireless communication range up to 100 ft", ...SYS, ...DIM, BTN_RESET],
    capabilities: caps.pack,
    specs: { "Input Voltage": "120–277V", "Mounting Height": "NA", "Max Communication Distance": "100 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "32°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Dimming": "Phase-cut TRIAC (forward / reverse phase)" },
    image: "/products/06935.png",
  },
  {
    id: "06930", orderNumber: "06930", name: "AC Powered BLE Controls — PIR",
    category: "Fixture Mounted", sensor: "PIR", power: "AC",
    applications: ["High-Bay"],
    tagline: "Fixture-mounted AC PIR control for high-bay up to 40 ft.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "120–277V", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 167°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06930.png",
  },
  {
    id: "06931", orderNumber: "06931", name: "AC Powered BLE Controls — PIR",
    category: "Fixture Mounted", sensor: "PIR", power: "AC",
    applications: ["High-Bay"],
    tagline: "IP65 fixture-mounted AC PIR high-bay control.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "120–277V", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06931.png",
  },
  {
    id: "06932", orderNumber: "06932", name: "AC Powered BLE Controls — PIR",
    category: "Fixture Mounted", sensor: "PIR", power: "AC",
    applications: ["High-Bay"],
    tagline: "120–480V fixture-mounted PIR control for demanding high-bay sites.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "120–480V", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06932.png",
  },
  {
    id: "06933", orderNumber: "06933", name: "AC Powered BLE Controls — PIR",
    category: "Fixture Mounted", sensor: "PIR", power: "AC",
    applications: ["High-Bay"],
    tagline: "Extended-range fixture PIR control — 328 ft communication.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 328 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "120–277V", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "328 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06933.png",
  },
  {
    id: "06936", orderNumber: "06936", name: "DC Powered BLE Controls — PIR",
    category: "Ceiling Mounted", sensor: "PIR", power: "DC",
    applications: ["Office", "Low-Bay"],
    tagline: "Ceiling-mounted PIR control for office and low-bay spaces.",
    overview: ["PIR motion detection", "Wide detection coverage", "Office / low-bay application ready", "Mounting height up to 13 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": SEE_DS, "Mounting Height": "Up to 13 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-4°F to 140°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06936.png",
  },
  {
    id: "06937", orderNumber: "06937", name: "AC Powered BLE Controls — PIR / Ultrasonic",
    category: "Ceiling Mounted", sensor: "PIR/Ultrasonic", power: "AC",
    applications: ["Office", "Low-Bay"],
    tagline: "Dual-technology PIR + Ultrasonic ceiling control.",
    overview: ["PIR / Ultrasonic (dual) motion detection", "Wide detection coverage", "Office / low-bay application ready", "Mounting height up to 13 ft", "Bluetooth Mesh connectivity", "360° coverage pattern", "Ultrasonic frequency of 40 kHz"],
    features: ["Wireless communication range up to 150 ft", ...SYS, ...DIM, BTN_RESET],
    capabilities: caps.indoor,
    specs: { "Input Voltage": "120–347V", "Mounting Height": "13 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "32°F to 131°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Ultrasonic Frequency": "40 kHz", "PIR Coverage": "44 ft" },
    image: "/products/06937.png",
  },
  {
    id: "06921", orderNumber: "06921", name: "DC Powered Outdoor BLE Controls — PIR",
    category: "Outdoor", sensor: "PIR", power: "DC",
    applications: ["Outdoor", "High-Bay"],
    tagline: "IP65 outdoor PIR control with photocell and scheduling.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, BTN_RESET],
    capabilities: caps.outdoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": SEE_DS, "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°" },
    image: "/products/06921.png",
  },
  {
    id: "06922", orderNumber: "06922", name: "DC Powered Outdoor BLE Controls — PIR",
    category: "Outdoor", sensor: "PIR", power: "DC",
    applications: ["Outdoor", "High-Bay"],
    tagline: "IP65 outdoor PIR control with photocell for perimeter lighting.",
    overview: ["PIR motion detection", "Wide detection coverage", "High-bay application ready", "Mounting height up to 40 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.outdoor,
    specs: { "Input Voltage": "12–24V DC", "Mounting Height": "Up to 40 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": SEE_DS, "IP Rating": "IP65", "Life Span": ">70,000 hours", "Coverage Pattern": "360°", "Thread": "G1/2" },
    image: "/products/06922.png",
  },
  {
    id: "06954", orderNumber: "06954", name: "AC Powered BLE Wall Outlet",
    category: "Wall Outlet", sensor: null, power: "AC",
    applications: ["Office"],
    tagline: "Bluetooth Mesh wall outlet for controlled receptacles.",
    overview: ["Wall-mount ON/OFF for connected devices", "Wide detection coverage", "Office application ready", "Bluetooth Mesh connectivity"],
    features: ["Wireless communication range up to 65 ft", ...SYS, "Reset: press and hold the switch buttons for 5 seconds to enter quick configure mode"],
    capabilities: ["Remote Control", "Scheduling", "Online Portal"],
    specs: { "Input Voltage": "120V", "Mounting Height": "NA", "Max Communication Distance": "65 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-14°F to 131°F", "IP Rating": "IP20", "Life Span": ">70,000 hours" },
    image: "/products/06954.png",
  },
  {
    id: "06970", orderNumber: "06970", name: "DC Powered BLE Controls — Long Range Extender",
    category: "Long Range Extender", sensor: null, power: "DC",
    applications: ["High-Bay"],
    tagline: "Extends Bluetooth Mesh reach up to 328 ft.",
    overview: ["Long Range Extender", "Wide detection coverage", "High-bay application ready", "Max Bluetooth range 328 ft", "Bluetooth Mesh connectivity", "360° coverage pattern"],
    features: ["Wireless communication range up to 150 ft", ...SYS, SCHED, ...DIM, REMOTE_RESET],
    capabilities: caps.node,
    specs: { "Input Voltage": "12–24V DC", "Max Bluetooth Range": "328 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP65", "Life Span": ">70,000 hours" },
    image: "/products/06970.png",
  },
  {
    id: "06971", orderNumber: "06971", name: "DC Powered BLE Controls — Long Range Extender",
    category: "Long Range Extender", sensor: null, power: "DC",
    applications: ["High-Bay"],
    tagline: "Extends Bluetooth Mesh reach up to 200 ft.",
    overview: ["Long Range Extender", "Wide detection coverage", "High-bay application ready", "Max Bluetooth range 200 ft", "Bluetooth Mesh connectivity"],
    features: ["Wireless communication range up to 150 ft", ...SYS, ...DIM, REMOTE_RESET],
    capabilities: caps.node,
    specs: { "Input Voltage": "12–24V DC", "Max Bluetooth Range": "200 ft", "Max Communication Distance": "150 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "-40°F to 158°F", "IP Rating": "IP65", "Life Span": ">70,000 hours" },
    image: "/products/06971.png",
  },
  {
    id: "06951", orderNumber: "06951", name: "AC Powered BLE Controls — PIR Wall Switch",
    category: "Wall Switch", sensor: "PIR", power: "AC",
    applications: ["Office"],
    tagline: "Wall-switch PIR occupancy control with 180° coverage.",
    overview: ["PIR wall-mount motion detection", "Wide detection coverage", "Office application ready", "Bluetooth Mesh connectivity", "180° coverage pattern"],
    features: ["Wireless communication range up to 100 ft", ...SYS, ...DIM, BTN_RESET],
    capabilities: caps.pirswitch,
    specs: { "Input Voltage": "120–277V", "Mounting Height": "Up to 4 ft", "Max Communication Distance": "100 ft", "Communication Protocol": "Bluetooth Mesh", "Operating Temperature": "32°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours", "Coverage Pattern": "180°" },
    image: "/products/06951.png",
  },
  {
    id: "06952", orderNumber: "06952", name: "Self-Powered BLE Wall Switch",
    category: "Wall Switch", sensor: null, power: "Self-Powered",
    applications: ["Office"],
    tagline: "No Wire, No Battery, No Limits.",
    overview: ["Wall-mount ON/OFF", "Wide detection coverage", "Office application ready", "Bluetooth Mesh connectivity", "No Wire, No Battery, No Limits", "2.4 GHz global operation"],
    features: ["Wireless communication range up to 100 ft", ...SYS, "Self-powered wall remote — no battery replacement and re-installation costs", "Ultra-long lifespan: more than 200,000 pushes", "Standard size, compatible with existing US-size frames", "On-board antenna", "Self-powered by built-in nano generator", "Click to turn ON; press and hold to increase light intensity. Click to turn OFF; press and hold to decrease light intensity"],
    capabilities: ["Self-Powered", "ON/OFF", "Remote Control"],
    specs: { "Input Voltage": "Self-powered by built-in nano generator", "Mounting Height": "NA", "Max Communication Distance": "100 ft", "Communication Protocol": "Bluetooth Mesh (2.4 GHz)", "Operating Temperature": "32°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours / 200,000+ pushes", "Frame": "Standard US-size compatible" },
    image: "/products/06952.png",
  },
  {
    id: "06953", orderNumber: "06953", name: "Self-Powered BLE Wall Switch — Dimming",
    category: "Wall Switch", sensor: null, power: "Self-Powered",
    applications: ["Office"],
    tagline: "No Wire, No Battery, No Limits. Now with dimming and scene recall.",
    overview: ["Wall-mount ON/OFF & dimming", "Wide detection coverage", "Office application ready", "Bluetooth Mesh connectivity", "No Wire, No Battery, No Limits", "2.4 GHz global operation"],
    features: ["Wireless communication range up to 100 ft", ...SYS, "Self-powered wall remote — no battery replacement and re-installation costs", "Ultra-long lifespan: more than 200,000 pushes", "Standard size, compatible with existing US-size frames", "On-board antenna", "Self-powered by built-in nano generator", "Click to turn ON/OFF; press and hold to dim up / down", "CW / WW buttons: click to recall scene, press and hold to tune cool / warm white"],
    capabilities: ["Self-Powered", "ON/OFF", "Dimming", "Scene Recall"],
    specs: { "Input Voltage": "Self-powered by built-in nano generator", "Mounting Height": "NA", "Max Communication Distance": "100 ft", "Communication Protocol": "Bluetooth Mesh (2.4 GHz)", "Operating Temperature": "32°F to 104°F", "IP Rating": "IP20", "Life Span": ">70,000 hours / 200,000+ pushes", "Frame": "Standard US-size compatible" },
    image: "/products/06953.png",
  },
];

export const CATEGORIES = ["Indoor", "Fixture Mounted", "Ceiling Mounted", "Outdoor", "Node", "Wall Switch", "Wall Outlet", "Long Range Extender"];
export const SENSORS = ["PIR", "OcuSense", "PIR/Ultrasonic"];
export const APPLICATIONS = ["Office", "Low-Bay", "High-Bay", "Outdoor"];
export const POWER = ["DC", "AC", "Self-Powered"];

export const getProduct = (id) => products.find((p) => p.id === id);
export const byCategory = (cat) => products.filter((p) => p.category === cat);
